// src/components/RequireAdmin.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * 관리자 전용 라우트 보호 컴포넌트
 * - 로딩 중: "인증 상태 확인 중..."
 * - 로그인 X: /login 으로 보냄
 * - 비밀번호 미변경: /change-password 로 보냄
 * - 관리자 아님: /main 으로 보냄
 */
function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "14px",
          color: "#555",
        }}
      >
        인증 상태 확인 중...
      </div>
    );
  }

  // 로그인 안 되어 있으면 로그인 페이지로
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 비밀번호를 변경하지 않은 경우 비밀번호 변경 페이지로 리다이렉트
  // 단, 이미 비밀번호 변경 페이지에 있으면 리다이렉트하지 않음
  if (user.password_changed === false && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  // 관리자(role !== 'admin')가 아니면 메인 페이지로
  if (user.role !== "admin") {
    return <Navigate to="/main" replace />;
  }

  return children;
}

export default RequireAdmin;